export default "__VITE_ASSET__$OFtKbHh__"